module.exports = __webpack_public_path__ + "static/TNM085_Boids_simulation-551adff47c4f54cb34f1fc3500dd5c91.pdf";